import { c as _c } from "react/compiler-runtime";
import { DEFAULT_TEAM_MEMBERS_SORT_BY, DEFAULT_MEMBERS_SORT_BY, DEFAULT_WORKSPACE_MEMBERS_SORT_BY, MEMBERS_SORT_BY_MAP, MEMBERS_SORT_OPTIONS, TEAM_MEMBERS_SORT_BY_MAP, TEAM_MEMBERS_SORT_OPTIONS } from "@components/table/members/members-sort-constants";
import { getMembersSortBy, getTeamMembersSortBy } from "@utils/member-utils";
import { isFieldVisibleForTableSubject } from "@components/table/members/members-table-utils";
import { getVisibleSortOptions } from "@utils/sort-utils";
import { MembersSortBase } from "@components/table/members/members-sort-base";

/** Component to change the members sort criteria */

export function MembersSort(props) {
  const $ = _c(13);
  if (props.tableSubject === "team") {
    let t0;
    if ($[0] !== props.setSortBy || $[1] !== props.sortBy) {
      t0 = <MembersSortBase sortBy={props.sortBy} setSortBy={props.setSortBy} sortOptions={TEAM_MEMBERS_SORT_OPTIONS} sortByMap={TEAM_MEMBERS_SORT_BY_MAP} defaultSortBy={DEFAULT_TEAM_MEMBERS_SORT_BY} getSortBy={getTeamMembersSortBy} subjectType="Team Member" />;
      $[0] = props.setSortBy;
      $[1] = props.sortBy;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  }
  const {
    tableSubject,
    sortBy,
    setSortBy
  } = props;
  let t0;
  if ($[3] !== props.hiddenFields) {
    t0 = new Set(props.hiddenFields);
    $[3] = props.hiddenFields;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const hiddenFields = t0;
  const defaultSortBy = isFieldVisibleForTableSubject("user", tableSubject) ? DEFAULT_WORKSPACE_MEMBERS_SORT_BY : DEFAULT_MEMBERS_SORT_BY;
  let t1;
  if ($[5] !== hiddenFields || $[6] !== tableSubject) {
    t1 = getVisibleSortOptions(MEMBERS_SORT_OPTIONS, field => isFieldVisibleForTableSubject(field, tableSubject) && !hiddenFields.has(field));
    $[5] = hiddenFields;
    $[6] = tableSubject;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const sortOptions = t1;
  let t2;
  if ($[8] !== defaultSortBy || $[9] !== setSortBy || $[10] !== sortBy || $[11] !== sortOptions) {
    t2 = <MembersSortBase sortBy={sortBy} setSortBy={setSortBy} sortOptions={sortOptions} sortByMap={MEMBERS_SORT_BY_MAP} defaultSortBy={defaultSortBy} getSortBy={getMembersSortBy} subjectType="Member" />;
    $[8] = defaultSortBy;
    $[9] = setSortBy;
    $[10] = sortBy;
    $[11] = sortOptions;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
}